const base = "/images";

const Resources = {
  images: {
    Header: {
      afliLogo: `${base}/Header/afliLogo.png`,
      afliHero: `${base}/Header/afliHero.jpg`
    },
    Stepper: {
      backArrow: `${base}/Stepper/backArrow.png`
    },
    FormDetails: {
      generalDetailsIcon: `${base}/FormDetails/generalDetailsIcon.png`,
      removeIcon: `${base}/FormDetails/removeIcon.svg`
    },
    Error: {
      icon: `${base}/Error/errorIcon.svg`
    },
    Select: {
      downIcon: `${base}/SelectField/downArrow.svg`,
      upIcon: `${base}/SelectField/upArrow.svg`
    },
    Dashboard: {
      sortIcon: `${base}/Dashboard/filter.svg`,
      downloadIcon: `${base}/Dashboard/download.svg`,
      upIcon: `${base}/Dashboard/up.svg`,
      upDisableIcon: `${base}/Dashboard/upDisable.svg`,
      loadingIcon: `${base}/Dashboard/loading.svg`,
      searchIcon: `${base}/Dashboard/searchIcon.svg`,
      filterIcon: `${base}/Dashboard/filterMobile.svg`,
      closeIcon: `${base}/Dashboard/close.svg`,
      idbiLogo: `${base}/Dashboard/IDBILogo.jpg`,
      federalLogo: `${base}/Dashboard/federalLogo.png`
    }
  }
};

export default Resources;
